import { useEffect, useState } from "react";
import { Singleton } from "../../../../../core/services/Singleton";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _HealthIDStructureItem } from "../../../../../core/services/dataBean/EntityCatalogVdos";

interface Props {
    idHealthIDStructure: number;
}

export const HealthIDStructureItem = ({ idHealthIDStructure }: Props) => {

    const item = useDataBean(_HealthIDStructureItem);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idHealthIDStructure])

    const getLista = () => {

        item.instance.getHealthIDStructureItemCatalog(idHealthIDStructure).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    //console.log(resp)
                }
            }
        )

    }

    const create = () => {
        item.setBean({
            IDHealthIDStructure: idHealthIDStructure
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        item.instance.deleteVoid(item.bean).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        item.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDHealthIDStructureItem', visible: true },
        { title: 'Nivel', property: 'Level', visible: true },
        { title: 'Nombre del ítem del rubro', property: 'Name', visible: true },
        { title: 'Máximo de Dígitos del item', property: 'MaxDigits', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <label>Items del código</label>
                <BasicTable body={lista} head={head} rowSet={item.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <label>Nivel</label>
                            <input type="Number" name="Level" className="form-control" value={item.bean.Level} onChange={(e) => { item.setBean({ ...item.bean, "Level": parseInt(e.target.value) }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Nombre del ítem del rubro</label>
                            <input type="text" name="Name" className="form-control" value={item.bean.Name} onChange={item.handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label>Máximo de Dígitos del item</label>
                            <input type="text" name="MaxDigits" className="form-control" value={item.bean.MaxDigits} onChange={item.handleChange} />
                        </div>
                        <div className="col-md-12">
                            <label>Description</label>
                            <textarea name="Description" className="form-control" value={item.bean.Description} onChange={item.handleChange} />
                        </div>
                    </div>
                </Modal>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}